<template>
    <div>
        <a-form :form="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }" @submit.native.prevent="handleSubmit"
                class="product-tab">
            <!--  经营规模 -->
            <a-form-item label="经营规模" :auto-link="false">
                <div>
                    <div style="margin-bottom: 4px;">
                        <a-button size="small" @mousedown.prevent="execCmd('bold', 'businessScale')"><b>B</b></a-button>
                        <input type="color" @focus="saveRange" @change="applyColorChange('businessScale', $event)"
                               style="width: 24px; height: 24px; border: none; cursor: pointer; vertical-align: middle; margin-left: 4px;"
                               title="文字颜色"/>
                            <a-button size="small" @mousedown.prevent="applyLastColor('businessScale')" style="margin-left: 4px;">确定</a-button>
                    </div>
                    <div contenteditable="true"
                         ref="businessScaleEditor"
                         @input="onRichInput('businessScale')"
                         @blur="onRichBlur('businessScale')"
                         class="rich-editor">
                    </div>
                    <a-input v-decorator="['businessScale']" style="display: none;"/>
                </div>
            </a-form-item>
            <!-- 代工模式 -->
            <a-form-item label="代工模式" :auto-link="false" class="daigong-form-item">
                <div v-decorator="['manufactureModeIds']" style="display: none;"></div>
                <div style="display: flex; align-items: center;">
                    <a-select placeholder="请选择代工模式" show-search :disabled="baseInfo.lang === 'EN'"
                              option-filter-prop="name" :filter-option="filterOption" v-model="daigongText" @change="handleFormChange">
                        <a-select-option v-for="(item) of availableDaigong" :key="item.tagId" :value="item.tagId">
                            {{ item.tagName }}
                        </a-select-option>
                    </a-select>
                    <a-button style="margin-left: 20px;" type="primary" @click="addDaigong" :disabled="baseInfo.lang === 'EN'">+ 新增</a-button>
                </div>
                <div ref="dragDaigong" style="width: 100%;margin-top:8px">
                    <div class="size_item mr12" style="width: 100%;" v-for="(item, idx) of daigongModeList"
                         :key="item.tagId">
                        <span class="left">{{ item.tagName }}</span>
                        <div class="right" v-if="baseInfo.lang !== 'EN'" @click="deleteDaigong(idx)">
                            <a-icon :style="{ fontSize: '20px', color: '#f00', cursor: 'pointer' }" type="delete"/>
                        </div>
                    </div>
                </div>
            </a-form-item>
            <!-- 合作模式 -->
            <a-form-item label="合作模式" :auto-link="false">
                <div>
                    <div style="margin-bottom: 4px;">
                        <a-button size="small" @mousedown.prevent="execCmd('bold', 'cooperationModel')"><b>B</b>
                        </a-button>
                        <input type="color" @focus="saveRange" @change="applyColorChange('cooperationModel', $event)"
                               style="width: 24px; height: 24px; border: none; cursor: pointer; vertical-align: middle; margin-left: 4px;"
                               title="文字颜色"/>
                            <a-button size="small" @mousedown.prevent="applyLastColor('cooperationModel')" style="margin-left: 4px;">确定</a-button>
                    </div>
                    <div contenteditable="true"
                         ref="cooperationModelEditor"
                         @input="onRichInput('cooperationModel')"
                         @blur="onRichBlur('cooperationModel')"
                         class="rich-editor">
                    </div>
                    <a-input v-decorator="['cooperationModel']" style="display: none;"/>
                </div>
            </a-form-item>
            <!-- 合作起订量 -->
            <a-form-item label="合作起订量" :auto-link="false">
                <div>
                    <div style="margin-bottom: 4px;">
                        <a-button size="small" @mousedown.prevent="execCmd('bold', 'cooperationOrderNum')"><b>B</b>
                        </a-button>
                        <input type="color" @focus="saveRange" @change="applyColorChange('cooperationOrderNum', $event)"
                               style="width: 24px; height: 24px; border: none; cursor: pointer; vertical-align: middle; margin-left: 4px;"
                               title="文字颜色"/>
                            <a-button size="small" @mousedown.prevent="applyLastColor('cooperationOrderNum')" style="margin-left: 4px;">确定</a-button>
                    </div>
                    <div contenteditable="true"
                         ref="cooperationOrderNumEditor"
                         @input="onRichInput('cooperationOrderNum')"
                         @blur="onRichBlur('cooperationOrderNum')"
                         class="rich-editor">
                    </div>
                    <a-input v-decorator="['cooperationOrderNum']" style="display: none;"/>
                </div>
            </a-form-item>
            <!-- 自有品牌 -->
            <a-form-item label="自有品牌" :auto-link="false">
                <div v-decorator="['brandIds']" style="display: none;"></div>
                <a-select placeholder="请选择自有品牌" show-search :disabled="baseInfo.lang === 'EN'"
                          option-filter-prop="name" :filter-option="filterOption" v-model="baseInfo.plText" @change="handleFormChange">
                    <a-select-option v-for="(item) of availableBrands" :key="item.businessId" :value="item.businessId">
                        {{ item.businessName }}
                    </a-select-option>
                </a-select>
                <a-button style="margin-top:8px;" type="primary" @click="addziyou" :disabled="baseInfo.lang === 'EN'">+ 新增</a-button>
                <div ref="dragContainerPL" style="width: 100%;">
                    <div class="size_item mr12" style="width: 100%;" v-for="(item, index) of plList"
                         :key="item.businessId">
                        <span class="left">{{ item.businessName }}</span>
                        <div class="right" v-if="baseInfo.lang !== 'EN'" @click="deletePL(index)">
                            <a-icon :style="{ fontSize: '20px', color: '#f00', cursor: 'pointer' }" type="delete"/>
                        </div>
                    </div>
                </div>
            </a-form-item>
            <!-- 合作品牌 -->
            <a-form-item label="合作品牌" :auto-link="false">
                <div v-decorator="['cooperationBrandIds']" style="display: none;"></div>
                <a-select placeholder="请选择合作品牌" show-search :disabled="baseInfo.lang === 'EN'"
                          option-filter-prop="name" :filter-option="filterOption" v-model="baseInfo.gyText" @change="handleFormChange">
                    <a-select-option v-for="(item) of availableCoopBrands" :key="item.businessId"
                                     :value="item.businessId">
                        {{ item.businessName }}
                    </a-select-option>
                </a-select>
                <a-button style="margin-top:8px;" type="primary" @click="addHZ" :disabled="baseInfo.lang === 'EN'">+ 新增</a-button>
                <div ref="dragContainerGY" style="width: 100%;">
                    <div class="size_item mr12" style="width: 100%;" v-for="(item, index) of gyList"
                         :key="item.businessId">
                        <span class="left">{{ item.businessName }}</span>
                        <div class="right" v-if="baseInfo.lang !== 'EN'" @click="deleteGY(index)">
                            <a-icon :style="{ fontSize: '20px', color: '#f00', cursor: 'pointer' }" type="delete"/>
                        </div>
                    </div>
                </div>
            </a-form-item>

            <!-- 核心服务商 -->
            <a-form-item label="核心服务商">
                <a-input v-model="patentText" placeholder="输入核心服务商"/>
                <a-button style="margin-top:8px;" type="primary" @click="addPatent">+ 新增</a-button>
                <div ref="dragPatent" style="width:100%;margin-top:8px">
                    <div class="size_item" v-for="(item,idx) of patentList" :key="item.id">
                        <span class="left">{{ item.name }}</span>
                        <a-icon class="right" type="delete" style="color:red;cursor:pointer;font-size:20px"
                                @click="delPatent(idx)"/>
                    </div>
                </div>
            </a-form-item>
            <!--  年产能（标注年份 -->
            <a-form-item label="年产能（标注年份）">
                <div style="flex-direction: row;display: flex;">
                    <a-input v-decorator="['annualCapacity']"
                             @input="handleFormChange" placeholder="年产能"/>
                    <a-input v-decorator="['annualCapacityYear']"
                             @input="handleFormChange" placeholder="年份"/>
                    <span style="margin-left: 4px;">年</span>
                </div>
            </a-form-item>
            <!--  年产值（标注年份 -->
            <a-form-item label="年产值（标注年份）">
                <div style="flex-direction: row;display: flex;">
                    <a-input v-decorator="['annualOutputValue']"
                             @input="handleFormChange" placeholder="年产值"/>
                    <a-input
                            v-decorator="['annualOutputValueYear']"
                            @input="handleFormChange" placeholder="年份"/>
                    <span style="margin-left: 4px;">年</span>
                </div>
            </a-form-item>
            <!--  工厂介绍 -->
            <a-form-item label="工厂介绍">
                <div>
                    <div style="margin-bottom: 4px;">
                        <a-button size="small" @mousedown.prevent="execCmd('bold', 'businessDesc')"><b>B</b></a-button>
                        <input type="color" @focus="saveRange" @change="applyColorChange('businessDesc', $event)"
                               style="width: 24px; height: 24px; border: none; cursor: pointer; vertical-align: middle; margin-left: 4px;"
                               title="文字颜色"/>
                            <a-button size="small" @mousedown.prevent="applyLastColor('businessDesc')" style="margin-left: 4px;">确定</a-button>
                    </div>
                    <div contenteditable="true"
                         ref="businessDescEditor"
                         @input="onRichInput('businessDesc')"
                         @blur="onRichBlur('businessDesc')"
                         class="rich-editor">
                    </div>
                    <a-input v-decorator="['businessDesc']" style="display: none;"/>
                </div>
            </a-form-item>
            <!--   工厂核心优势 -->
            <a-form-item label="工厂核心优势">
                <div style="position: relative;">
                    <div style="margin-bottom: 4px;">
                        <a-button size="small" @mousedown.prevent="execCmd('bold', 'businessCoreAdvantage')"><b>B</b>
                        </a-button>
                        <input type="color" @focus="saveRange" @change="applyColorChange('businessCoreAdvantage', $event)"
                               style="width: 24px; height: 24px; border: none; cursor: pointer; vertical-align: middle; margin-left: 4px;"
                               title="文字颜色"/>
                            <a-button size="small" @mousedown.prevent="applyLastColor('businessCoreAdvantage')" style="margin-left: 4px;">确定</a-button>
                    </div>
                    <div contenteditable="true"
                         ref="businessCoreAdvantageEditor"
                         @input="onRichInput('businessCoreAdvantage')"
                         @blur="onRichBlur('businessCoreAdvantage')"
                         class="rich-editor">
                    </div>

                    <a-input v-decorator="['businessCoreAdvantage']" style="display: none;"/>
                </div>
            </a-form-item>


            <div v-for="(mod, mIdx) in bigModules" :key="mod._key" style="margin-bottom: 20px;">
                <a-form-item>
                    <a-input slot="label" v-model="mod.key" placeholder="标题" style="width: 50%;"
                             @input="clearModuleError(mIdx, 'key')"/>
                    <div style="position: relative;">
                        <div style="margin-bottom: 4px;">
                            <a-button size="small" @mousedown.prevent="execCmdModule('bold', mIdx)"><b>B</b></a-button>
                            <input type="color" @focus="saveRangeModule" @change="applyModuleColorChange(mIdx, $event)"
                                   style="width: 24px; height: 24px; border: none; cursor: pointer; vertical-align: middle; margin-left: 4px;"
                                   title="文字颜色"/>
                            <a-button size="small" @mousedown.prevent="applyLastModuleColor(mIdx)" style="margin-left: 4px;">确定</a-button>
                            <a-icon type="delete"
                                    style="color: red; cursor: pointer; font-size: 18px;vertical-align: middle;margin-left: 10px "
                                    @click="removeBigModule(mIdx)"/>
                        </div>
                        <div contenteditable="true"
                             @input="onModuleInput(mIdx, $event)"
                             class="rich-editor big-module-editor">
                        </div>

                    </div>
                </a-form-item>
            </div>

            <a-row style="margin-top: -8px; margin-bottom: 16px;">
                <a-col :span="4"></a-col>
                <a-col :span="8" style="text-align: right;">
                    <a-button type="primary" @click="totalAddBJ">+ 添加</a-button>
                </a-col>
            </a-row>

            <div class="tabTitle" style="">
                工厂环境
            </div>
            <a-tabs default-active-key="1" tab-position="top">
                <a-tab-pane key="1" tab="图片">
                    <FactoryImageUpload v-model="factoryImages" :errors="imageErrors" @input="clearImageErrors"/>
                </a-tab-pane>
                <a-tab-pane key="2" tab="视频">
                    <FactoryVideoUpload v-model="factoryVideos" :errors="videoErrors" @input="clearVideoErrors"/>
                </a-tab-pane>
                <a-tab-pane key="3" tab="资质">
                    <FactoryCertUpload v-model="factoryCerts" :errors="certErrors" @input="clearCertErrors"/>
                </a-tab-pane>
                <a-tab-pane key="4" tab="VR">
                    <FactoryVRUpload ref="vrRef" :value="{ vrUrl, vrStatus }" @input="onVRChange"/>
                </a-tab-pane>
            </a-tabs>
            <a-form-item :wrapper-col="{ span: 24 }" style="text-align: center;">
                <a-button type="primary" html-type="submit" size="large">
                    保存
                </a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
    import Sortable from 'sortablejs'
    import {
        ossUpload
    } from "../../../utils/oss";
    import {
        factoryBusinessApi
    } from "../../../api/index";

    // 子组件
    import FactoryImageUpload from '../JY/FactoryImageUpload.vue'
    import FactoryVideoUpload from '../JY/FactoryVideoUpload.vue'
    import FactoryCertUpload from '../JY/FactoryCertUpload.vue'
    import FactoryVRUpload from '../JY/FactoryVRUpload.vue'

    export default {
        components: {
            FactoryImageUpload,
            FactoryVideoUpload,
            FactoryCertUpload,
            FactoryVRUpload // 注册组件
        },
        name: "BaseInfoTab",
        props: {
            ifFacOrBr: {
                type: String,
                default: ""
            },
            initialData: Object,
            brandList: { // （品牌列表）
                type: Array,
                default: () => []
            },
            daigongList: { // 代工模式
                type: Array,
                default: () => []
            },
            // pinleiList: { // 品类（工厂）
            // 	type: Array,
            // 	default: () => []
            // },
            // gongyiList: { // 工艺（工厂）
            // 	type: Array,
            // 	default: () => []
            // },
            // zhuyingList: { // 主营（工厂）
            // 	type: Array,
            // 	default: () => []
            // }
        },
        data() {
            return {
                // 新增：图片/视频/VR 数据
                factoryImages: [],
                factoryVideos: [],
                factoryCerts: [],
                vrUrl: '',
                vrStatus: false,
                bigModules: [],
                bigModuleErrors: [],
                imageErrors: [],
                videoErrors: [],
                certErrors: [],
                moduleSavedRange: null,
                moduleColorPicked: '',
                lastColor: {},
                lastColorModule: {},
                pickedColor: '',
                form: this.$form.createForm(this),
                // 本地表单数据
                baseInfo: {},
                // 原始数据（用于对比是否修改）
                originBaseInfo: {},

                plList: [], // 品类列表
                gyList: [], // 工艺列表
                zyList: [], // 主营列表

                list: [{
                    tagId: 1,
                    tagName: "001"
                },
                    {
                        tagId: 2,
                        tagName: "002"
                    },
                    {
                        tagId: 3,
                        tagName: "003"
                    }
                ],

                // 输入型（专利/特色原料/特色工艺/权威合作）
                patentList: [], // 专利技术
                processList: [], // 特色工艺
                partnershipList: [], // 权威合作
                daigongModeList: [], // 代工模式（存储对象 {tagId, tagName}）

                patentText: '',
                processText: '',
                partnerText: '',
                daigongText: undefined,
                sortableInstances: [],
            };
        },
        computed: {
            availableBrands() {
                const addedIds = this.plList.map(item => String(item.businessId));
                return this.brandList.filter(item => !addedIds.includes(String(item.businessId)));
            },
            availableCoopBrands() {
                const addedIds = this.gyList.map(item => String(item.businessId));
                return this.brandList.filter(item => !addedIds.includes(String(item.businessId)));
            },
            availableDaigong() {
                const added = this.daigongModeList.map(i => String(i.tagId));
                return this.daigongList.filter(i => !added.includes(String(i.tagId)));
            },
        },
        watch: {
            // 监听父组件数据更新 → 自动回填
            initialData: {
                deep: true,
                immediate: true,
                handler(val) {
                    if (val) {
                        this.initFormData(val);
                    }
                }
            },
            brandList: {
                deep: true,
                handler() {
                    this.syncBrandLists();
                }
            },
            daigongList: {
                deep: true,
                handler() {
                    this.syncDaigongModeList();
                }
            },
            // 深度监听 baseInfo：捕获所有 v-model 修改
            baseInfo: {
                deep: true,
                handler() {
                    this.handleFormChange()
                }
            },
            // 英文版禁用拖拽
            'baseInfo.lang'(newVal, oldVal) {
                this.applySortableDisabled();
            }
        },
        mounted() {
            this.initAllDrag()
        },
        created() {
            this.baseInfo = JSON.parse(JSON.stringify(this.initialData || {}));
            this.originBaseInfo = JSON.parse(JSON.stringify(this.baseInfo));
        },
methods: {
            mapSavedIds(value, source, idKey) {
                if (!value) return [];
                const ids = String(value).split(',').filter(Boolean);
                const itemMap = {};
                source.forEach(item => {
                    itemMap[String(item[idKey])] = item;
                });
                return ids.map(id => itemMap[String(id)]).filter(Boolean);
            },
            syncBrandLists() {
                this.plList = this.mapSavedIds(this.baseInfo.brandIds, this.brandList, 'businessId');
                this.gyList = this.mapSavedIds(this.baseInfo.cooperationBrandIds, this.brandList, 'businessId');
            },
            syncDaigongModeList() {
                this.daigongModeList = this.mapSavedIds(this.baseInfo.manufactureModeIds, this.daigongList, 'tagId');
            },
            initFormData(data) {
                if (!data) return;

                this.baseInfo = JSON.parse(JSON.stringify(data || {}));
                if (this.baseInfo.businessLangId) {
                    this.businessLangId = this.baseInfo.businessLangId
                }


                this.originBaseInfo = JSON.parse(JSON.stringify(this.baseInfo));
                // ==============================================
                // antd 表单赋值
                // ==============================================
                const bizScale = this.baseInfo.businessScale || '';
                const coopModel = this.baseInfo.cooperationModel || '';
                const coopOrder = this.baseInfo.cooperationOrderNum || '';
                const bizDesc = this.baseInfo.businessDesc || '';
                const bizCore = this.baseInfo.businessCoreAdvantage || '';

                this.$nextTick(() => {
                    this.form.setFieldsValue({
                        brandIds: this.baseInfo.brandIds || '',
                        cooperationBrandIds: this.baseInfo.cooperationBrandIds || '',
                        businessScale: bizScale,
                        cooperationModel: coopModel,
                        cooperationOrderNum: coopOrder,
                        annualCapacity: this.baseInfo.annualCapacity || '',
                        annualCapacityYear: this.baseInfo.annualCapacityYear || '',
                        annualOutputValue: this.baseInfo.annualOutputValue || '',
                        annualOutputValueYear: this.baseInfo.annualOutputValueYear || '',
                        businessDesc: bizDesc,
                        businessCoreAdvantage: bizCore,
                    });
                    // 回显富文本编辑器
                    this.$nextTick(() => {
                        if (this.$refs.businessScaleEditor) this.$refs.businessScaleEditor.innerHTML = bizScale;
                        if (this.$refs.cooperationModelEditor) this.$refs.cooperationModelEditor.innerHTML = coopModel;
                        if (this.$refs.cooperationOrderNumEditor) this.$refs.cooperationOrderNumEditor.innerHTML = coopOrder;
                        if (this.$refs.businessDescEditor) this.$refs.businessDescEditor.innerHTML = bizDesc;
                        if (this.$refs.businessCoreAdvantageEditor) this.$refs.businessCoreAdvantageEditor.innerHTML = bizCore;
                    });
                });

                // ==============================================
                //回显品牌，和核心服务商
                this.syncBrandLists();
                this.syncDaigongModeList();

                // ==============================================
                // 2. 回显：核心服务商 patentList
                // ==============================================
                this.patentList = this.baseInfo.serviceProvider
                    ? this.baseInfo.serviceProvider.split(';').filter(Boolean).map((name, i) => ({
                        id: Date.now() + i,
                        name
                    }))
                    : [];

                if (this.baseInfo.otherFactorDesc) {
                    try {
                        const arr = JSON.parse(this.baseInfo.otherFactorDesc);
                        this.bigModules = (arr || []).map(item => ({ ...item, _key: Date.now() + '_' + Math.random() }))
                        // 回显富文本编辑器内容
                        this.$nextTick(() => {
                            const editors = this.$el.querySelectorAll('.big-module-editor');
                            editors.forEach((el, i) => {
                                if (this.bigModules[i]) {
                                    el.innerHTML = this.bigModules[i].value || '';
                                }
                            });
                        });
                    } catch (e) {
                        this.bigModules = [];
                    }
                } else {
                    this.bigModules = [];
                }

                // 图片/视频 回显
                this.factoryImages = Array.isArray(data.factoryEnvironmentImages)
                    ? JSON.parse(JSON.stringify(data.factoryEnvironmentImages))
                    : [];
                this.factoryVideos = Array.isArray(data.factoryEnvironmentVideos)
                    ? JSON.parse(JSON.stringify(data.factoryEnvironmentVideos))
                    : [];
                this.factoryCerts = Array.isArray(data.factoryEnvironmentCerts)
                    ? JSON.parse(JSON.stringify(data.factoryEnvironmentCerts))
                    : [];

                // VR 回显
                this.vrUrl = data.vrUrl || '';
                this.vrStatus = data.vrStatus || false;


                this.$emit('dirty', false);
            },
            // ======================
            handleFormChange() {
                const isModified = JSON.stringify(this.baseInfo) !== JSON.stringify(this.originBaseInfo);
                this.$emit("dirty", isModified);
            },
            onVRChange(val) {
                this.vrUrl = val.vrUrl;
                this.vrStatus = val.vrStatus;
            },
            // 统一初始化所有拖拽
            // 英文版禁用拖拽
            applySortableDisabled() {
                const disabled = this.baseInfo.lang === 'EN'
                this.sortableInstances.forEach(s => {
                    if (s && typeof s.option === 'function') {
                        s.option('disabled', disabled)
                    }
                })
            },
            initAllDrag() {
                // 品类
                this.createDrag('dragContainerPL', this.plList)
                // 工艺
                this.createDrag('dragContainerGY', this.gyList)
                // 主营
                this.createDrag('dragPatent', this.patentList)
                // 代工模式
                this.createDrag('dragDaigong', this.daigongModeList)

            },
            // 拖拽通用方法
            createDrag(refName, list) {
                const el = this.$refs[refName]
                if (!el) return
                const sortable = Sortable.create(el, {
                    animation: 150,
                    draggable: '.size_item',
                    ghostClass: 'sort-ghost',

                    onEnd: (evt) => {
                        // 重要：不用闭包传入的旧 list，通过 refName 实时读取当前数据数组
                        const listNameMap = {
                            dragContainerPL: 'plList',
                            dragContainerGY: 'gyList',
                            dragPatent: 'patentList',
                            dragDaigong: 'daigongModeList',
                        }
                        const list = this[listNameMap[refName]]
                        const {
                            oldIndex,
                            newIndex
                        } = evt
                        const moveItem = list.splice(oldIndex, 1)[0]
                        list.splice(newIndex, 0, moveItem)
                    }
                })
                if (['dragContainerPL', 'dragContainerGY', 'dragDaigong'].includes(refName)) {
                    this.sortableInstances.push(sortable)
                    sortable.option('disabled', this.baseInfo.lang === 'EN')
                }
            },
            onChange(value, selectedOptions) {
                this.baseInfo.province = selectedOptions[0].text
                this.baseInfo.provinceCode = selectedOptions[0].value
                this.baseInfo.city = selectedOptions[1].text
                this.baseInfo.cityCode = selectedOptions[2].value
            },

            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().includes(input.toLowerCase());
            },

            // ======================
            // 品类（质量认证）
            // ======================
            addziyou() {
                const val = this.baseInfo.plText;
                if (!val) return this.$msg.warning('请选择');
                const exist = this.plList.some(i => i.businessId == val);
                if (exist) return this.$msg.warning('已添加');
                const item = this.brandList.find(i => i.businessId == val);
                if (item) {
                    this.plList.push(item);
                    this.baseInfo.brandIds = this.plList.map(i => i.businessId).join(',');
                    this.form.setFieldsValue({brandIds: this.baseInfo.brandIds});
                    this.baseInfo.plText = undefined;
                    this.form.setFieldsValue({plText: undefined});
                }
            },
            deletePL(idx) {
                this.plList.splice(idx, 1);
                this.baseInfo.brandIds = this.plList.map(i => i.businessId).join(',');
                this.form.setFieldsValue({brandIds: this.baseInfo.brandIds});
                this.handleFormChange();
            },

            // ======================
            // 工艺（生产资质）
            // ======================
            addHZ() {
                const val = this.baseInfo.gyText;
                if (!val) return this.$msg.warning('请选择');
                const exist = this.gyList.some(i => i.businessId == val);
                if (exist) return this.$msg.warning('已添加');
                const item = this.brandList.find(i => i.businessId == val);
                if (item) {
                    this.gyList.push(item);
                    this.baseInfo.cooperationBrandIds = this.gyList.map(i => i.businessId).join(',');
                    this.form.setFieldsValue({cooperationBrandIds: this.baseInfo.cooperationBrandIds});
                    this.baseInfo.gyText = undefined;
                    this.form.setFieldsValue({gyText: undefined});
                }
            },
            deleteGY(idx) {
                this.gyList.splice(idx, 1);
                this.baseInfo.cooperationBrandIds = this.gyList.map(i => i.businessId).join(',');
                this.form.setFieldsValue({cooperationBrandIds: this.baseInfo.cooperationBrandIds});
                this.handleFormChange();
            },

            // ======================
            // 主营（供应商）
            // ======================
            addZY() {
                const val = this.baseInfo.zyText;
                if (!val) return this.$msg.warning('请选择');
                const exist = this.zyList.some(i => i.tagId == val);
                if (exist) return this.$msg.warning('已添加');
                const item = this.zhuyingList.find(i => i.tagId == val);
                if (item) this.zyList.push(item);
            },
            deleteZY(idx) {
                this.zyList.splice(idx, 1);
            },

            // ======================
            // 代工模式
            // ======================
            addDaigong() {
                const val = this.daigongText;
                if (!val) return this.$msg.warning('请选择');
                const exist = this.daigongModeList.some(i => i.tagId == val);
                if (exist) return this.$msg.warning('已添加');
                const item = this.daigongList.find(i => i.tagId == val);
                if (item) {
                    this.daigongModeList.push(item);
                    this.baseInfo.manufactureModeIds = this.daigongModeList.map(i => i.tagId).join(',');
                    this.form.setFieldsValue({manufactureModeIds: this.baseInfo.manufactureModeIds});
                    this.daigongText = undefined;
                }
                this.handleFormChange();
            },
            deleteDaigong(idx) {
                this.daigongModeList.splice(idx, 1);
                this.baseInfo.manufactureModeIds = this.daigongModeList.map(i => i.tagId).join(',');
                this.form.setFieldsValue({manufactureModeIds: this.baseInfo.manufactureModeIds});
                this.handleFormChange();
            },

            // ======================
            // 输入型：专利技术
            // ======================
            addPatent() {
                if (!this.patentText) return;
                this.patentList.push({
                    id: Date.now(),
                    name: this.patentText
                });
                this.baseInfo.serviceProvider = this.patentList.map(i => i.name).join(';');
                this.patentText = '';
                this.handleFormChange();
            },
            delPatent(idx) {
                this.patentList.splice(idx, 1);
                this.baseInfo.serviceProvider = this.patentList.map(i => i.name).join(';');
                this.handleFormChange();
            },

            // ======================
            // 输入型：特色工艺
            // ======================
            addProcess() {
                if (!this.processText) return;
                this.processList.push(this.processText);
                this.processText = '';
            },
            delProcess(idx) {
                this.processList.splice(idx, 1);
            },

            // ======================
            // 输入型：权威合作
            // ======================
            addPartner() {
                if (!this.partnerText) return;
                this.partnershipList.push(this.partnerText);
                this.partnerText = '';
            },
            delPartner(idx) {
                this.partnershipList.splice(idx, 1);
            },

            // ======================
            // 提交前拼接字符串
            // ======================
            // getSubmitData() {
            // 	return {
            // 		categoryIds: ,
            // 		craftsmanshipIds: ,
            // 		coreBusinessIds: this.zyList.map(i => i.tagId).join(','),
            // 		patentTechnology: this.patentList.join(';'),
            // 		featuredRawMaterials: this.rawMaterialList.join(';'),
            // 		featuredProcesses: this.processList.join(';'),
            // 		authoritativePartnerships: this.partnershipList.join(';'),
            // 	};
            // },

            // ======================
            // 提交
            // ======================
            handleSubmit() {
                this.form.validateFields(async (err, values) => {
                    if (!err) {
                        await this.saveData(values);

                    }
                });
            },
            getBigModulesSubmitStr() {
                const result = this.bigModules.map(item => {
                    return {
                        key: item.key || '',
                        value: item.value || ''
                    };
                });
                return JSON.stringify(result);
            },
            async saveData(values) {
                // 1. 你子组件传出来的数据
                const originalList = this.factoryImages;
                const originalListVideo = this.factoryVideos;

                let hasError = false;

                this.imageErrors = [];
                for (let i = 0; i < originalList.length; i++) {
                    const item = originalList[i];
                    const brandLine = (item.brandLine || '').trim();
                    const factoryImages = (item.factoryImages || '').trim();

                    // 规则：同一组全部为空 → 不校验
                    // if (!brandLine && !factoryImages) continue;

                    const err = {};
                    if (!brandLine) err.brandLine = true;
                    if (!factoryImages) err.factoryImages = true;
                    if (Object.keys(err).length > 0) {
                        this.$set(this.imageErrors, i, err);
                        hasError = true;
                    }
                }

                this.videoErrors = [];
                for (let i = 0; i < originalListVideo.length; i++) {
                    const item = originalListVideo[i];
                    const brandLine = (item.brandLine || '').trim();
                    const factoryImages = (item.factoryImages || '').trim();
                    const factoryVideo = (item.factoryVideo || '').trim();

                    // 规则：同一组全部为空 → 不校验

                    const err = {};
                    if (!brandLine) err.brandLine = true;
                    if (!factoryImages) err.factoryImages = true;
                    if (!factoryVideo) err.factoryVideo = true;
                    if (Object.keys(err).length > 0) {
                        this.$set(this.videoErrors, i, err);
                        hasError = true;
                    }
                }

                // 校验资质
                const originalListCert = this.factoryCerts;
                this.certErrors = [];
                for (let i = 0; i < originalListCert.length; i++) {
                    const item = originalListCert[i];
                    const brandLine = (item.brandLine || '').trim();
                    const factoryImages = (item.factoryImages || '').trim();

                    const err = {};
                    if (!brandLine) err.brandLine = true;
                    if (!factoryImages) err.factoryImages = true;
                    if (Object.keys(err).length > 0) {
                        this.$set(this.certErrors, i, err);
                        hasError = true;
                    }
                }

                // 校验不通过 → 直接终止提交
                if (hasError) {
                    if (this.imageErrors.length > 0) {
                        this.$message.warning('请完善工厂环境中的图片项');
                    } else if (this.videoErrors.length > 0) {
                        this.$message.warning('请完善工厂环境中的视频项');
                    } else if (this.certErrors.length > 0) {
                        this.$message.warning('请完善工厂环境中的资质项');
                    }
                    return;
                }

                // 校验VR地址
                if (this.$refs.vrRef && !this.$refs.vrRef.validate()) {
                    return;
                }

                // bigModules 校验：标题和内容都必须填
                this.bigModuleErrors = [];
                for (let i = 0; i < this.bigModules.length; i++) {
                    const mod = this.bigModules[i];
                    const key = (mod.key || '').trim();
                    const value = (mod.value || '').replace(/<[^>]*>/g, '').trim();
                    // if (!key && !value) continue; // 全空跳过
                    const err = {};
                    if (!key) err.key = true;
                    if (!value) err.value = true;
                    if (Object.keys(err).length > 0) {
                        this.$set(this.bigModuleErrors, i, err);
                        hasError = true;
                    }
                }
                if (this.bigModuleErrors.length > 0) {
                    this.$message.warning('请完善经营信息添加项');
                    return;
                }

                // 2. 转换成后端要的格式（只保留 brandLine + factoryImages）
                const factoryEnvironmentImages = originalList.map(item => {
                    return {
                        brandLine: item.brandLine,
                        factoryImages: item.factoryImages
                    };
                });
                const factoryEnvironmentVideos = originalListVideo.map(item => {
                    return {
                        brandLine: item.brandLine,
                        factoryImages: item.factoryImages,
                        factoryVideo: item.factoryVideo
                    };
                });


                const factoryEnvironmentCerts = originalListCert.map(item => {
                    return {
                        brandLine: item.brandLine,
                        factoryImages: item.factoryImages
                    };
                });

                let params = {
                    "businessLangId": this.initialData.businessLangId,
                    "businessScale": values.businessScale, //经营规模
                    "cooperationModel": this.normalizeRichHtml(values.cooperationModel), //合作模式ID  多个,隔开
                    "cooperationOrderNum": values.cooperationOrderNum, //合作起订量
                    "brandIds": this.plList.map(i => i.businessId).join(','), //自有品牌Id 多个,隔开
                    "cooperationBrandIds": this.gyList.map(i => i.businessId).join(','), //合作品牌Id 多个,隔开
                    "manufactureModeIds": this.daigongModeList.map(i => i.tagId).join(','), //代工模式 多个,隔开
                    "serviceProvider": this.patentList.map(i => i.name).join(';'), //核心服务商 多个;隔开
                    "annualCapacity": values.annualCapacity, //年产能
                    "annualCapacityYear": values.annualCapacityYear, //年产能 年份
                    "annualOutputValue": values.annualOutputValue, //年产值
                    "annualOutputValueYear": values.annualOutputValueYear, //年产值 年份
                    "businessDesc": values.businessDesc, //工厂介绍 /品牌介绍
                    "businessCoreAdvantage": values.businessCoreAdvantage, //工厂核心优势
                    //  工厂核心优势 其他描述  json字符串
                    "otherFactorDesc": JSON.stringify(this.bigModules),
                    "factoryEnvironmentImages": factoryEnvironmentImages,
                    "factoryEnvironmentVideos": factoryEnvironmentVideos,
                    "factoryEnvironmentCerts": factoryEnvironmentCerts,
                    "vrUrl": this.vrUrl,
                    "vrStatus": this.vrStatus
                }
                return factoryBusinessApi(params).then(res => {
                    if (!res.resultStatus) {
                        this.$message.error(res.errorMessage || '保存失败');
                        return false;
                    }
                    this.originBaseInfo = JSON.parse(JSON.stringify(this.baseInfo));
                    this.$emit('dirty', false);
                    this.$emit('saved', { businessLangId: res.resultData });
					this.$message.success("保存成功");
                    return true;
                }).catch(() => {
                    this.$message.error('保存失败');
                    return false;
                });
            },

            // ======================
            // 富文本编辑器
            // ======================
            saveRange() {
                const sel = window.getSelection();
                if (sel.rangeCount > 0) {
                    this.savedRange = sel.getRangeAt(0).cloneRange();
                }
            },
            execCmd(cmd, field) {
                document.execCommand(cmd, false, null);
                this.onRichInput(field);
            },
            execForeColor(field, e) {
                // 恢复之前保存的选区（取色器弹出时已失焦）
                if (this.savedRange) {
                    const sel = window.getSelection();
                    sel.removeAllRanges();
                    sel.addRange(this.savedRange);
                }
                document.execCommand('foreColor', false, e.target.value);
                this.savedRange = null;
                this.onRichInput(field);
            },
            normalizeRichHtml(html) {
                const value = String(html || '').trim();
                if (!value) return '';

                const textOnly = value
                    .replace(/<br\s*\/?\s*>/gi, '')
                    .replace(/&nbsp;/gi, '')
                    .replace(/<[^>]*>/g, '')
                    .trim();
                return textOnly ? value : '';
            },
            onRichInput(field) {
                const refMap = {
                    businessScale: 'businessScaleEditor',
                    cooperationModel: 'cooperationModelEditor',
                    cooperationOrderNum: 'cooperationOrderNumEditor',
                    businessDesc: 'businessDescEditor',
                    businessCoreAdvantage: 'businessCoreAdvantageEditor',
                };
                const refName = refMap[field];
                const el = this.$refs[refName];
                const html = this.normalizeRichHtml(el ? el.innerHTML : '');
                this.form.setFieldsValue({[field]: html});
            },
            onRichBlur(field) {
                this.onRichInput(field);
                this.handleFormChange();
            },

            totalAddBJ() {
                this.bigModules.push({
                    key: '',
                    value: '',
                    _key: Date.now() + '_' + Math.random()
                })
            },
            saveRangeModule() {
                const sel = window.getSelection();
                if (sel.rangeCount > 0) {
                    this.moduleSavedRange = sel.getRangeAt(0).cloneRange();
                }
            },
            execCmdModule(cmd, idx) {
                document.execCommand(cmd, false, null);
                const el = document.activeElement;
                if (el && el.contentEditable === 'true') {
                    this.bigModules[idx].value = el.innerHTML;
                }
            },
            applyColorChange(field, event) {
                const color = event.target.value;
                if (!color) return;
                this.lastColor[field] = color;
                if (this.savedRange) {
                    const sel = window.getSelection();
                    try {
                        sel.setBaseAndExtent(
                            this.savedRange.startContainer,
                            this.savedRange.startOffset,
                            this.savedRange.endContainer,
                            this.savedRange.endOffset
                        );
                    } catch (e) {
                        sel.removeAllRanges();
                        sel.addRange(this.savedRange);
                    }
                }
                document.execCommand('foreColor', false, color);
                this.savedRange = null;
                this.onRichInput(field);
            },
            applyLastColor(field) {
                const color = this.lastColor[field];
                if (!color) return;
                document.execCommand('foreColor', false, color);
                this.onRichInput(field);
            },
            applyModuleColorChange(idx, event) {
                const color = event.target.value;
                if (!color) return;
                this.lastColorModule[idx] = color;
                if (this.moduleSavedRange) {
                    const sel = window.getSelection();
                    try {
                        sel.setBaseAndExtent(
                            this.moduleSavedRange.startContainer,
                            this.moduleSavedRange.startOffset,
                            this.moduleSavedRange.endContainer,
                            this.moduleSavedRange.endOffset
                        );
                    } catch (e) {
                        sel.removeAllRanges();
                        sel.addRange(this.moduleSavedRange);
                    }
                }
                document.execCommand('foreColor', false, color);
                this.moduleSavedRange = null;
                const editor = document.querySelectorAll('.big-module-editor')[idx];
                this.onModuleInput(idx, { target: editor || {} });
            },
            applyLastModuleColor(idx) {
                const color = this.lastColorModule[idx];
                if (!color) return;
                document.execCommand('foreColor', false, color);
                const editor = document.querySelectorAll('.big-module-editor')[idx];
                this.onModuleInput(idx, { target: editor || {} });
            },
            execForeColorModule(idx, e) {
                if (this.moduleSavedRange) {
                    const sel = window.getSelection();
                    sel.removeAllRanges();
                    sel.addRange(this.moduleSavedRange);
                }
                document.execCommand('foreColor', false, e.target.value);
                this.moduleSavedRange = null;
                const el = document.activeElement;
                if (el && el.contentEditable === 'true') {
                    this.bigModules[idx].value = el.innerHTML;
                }
            },
            onModuleInput(idx, e) {
                this.bigModules[idx].value = e.target.innerHTML;
            },
            clearImageErrors() {
                this.imageErrors = [];
            },
            clearVideoErrors() {
                this.videoErrors = [];
            },
            clearCertErrors() {
                this.certErrors = [];
            },
            clearModuleError(idx, field) {
                if (this.bigModuleErrors[idx]) {
                    this.$set(this.bigModuleErrors[idx], field, false);
                }
            },
            removeBigModule(idx) {
                this.bigModules.splice(idx, 1);
                this.bigModuleErrors.splice(idx, 1);
            },
        },
    };
</script>

<style scoped lang="less">
    .product-tab {
        padding: 16px 16px 16px 0;
    }

    // 代工模式：label 顶部对齐到下拉框
    .daigong-form-item /deep/ .ant-form-item-label {
        line-height: 32px;
    }

    .tabTitle {
        width: 100%;
        height: 40px;
        background-color: #4182FF1A;
        font-size: 16px;
        color: #333;
        line-height: 38px;
        padding-left: 40px;
        font-weight: bold;
    }

    .mt12 {
        margin-top: 12px;
    }

    .mr12 {
        margin-right: 12px;
    }

    .sort-ghost {
        opacity: 0.5;
        background: #f5f5f5;
    }

    .size_item {
        height: 50px;
        /* 改为固定高度，不要 min-height */
        background: #f7f7f7;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 8px 0;
        /* 间距改小，更美观 */
        cursor: move;
        padding: 0 10px;

        .left {
            flex: 1;
            padding-left: 10px;
        }

        .right {
            width: 50px;
            text-align: center;
        }
    }

    .rich-editor {
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        padding: 4px 11px;
        min-height: 96px;
        line-height: 1.5;
        outline: none;
        transition: border-color 0.3s;

        &:focus {
            border-color: #1890ff;
            box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
        }
    }
</style>
